// Module
var code = "<pricep-form model=\"vm.pricep\"\n    on-save=\"$close(model)\"\n    on-close=\"$close()\">\n</pricep-form>\n";
// Exports
module.exports = code;